<template lang="html">
  <section class="form-box">
    <div class="container">
      <div class="row">
        <h2 class="urlap-title">Szolgáltatás kiválasztása</h2>
      </div>
      <div class="row radio-selection" >
        <div class="form-box-item" v-for="(data,key) in fieldOptions" v-bind:key="key">
          <input
            type="radio"
            :id="'radio-'+field+'-'+key"
            :name="field"
            :value="key"
            v-model="service_type"
          >
          <label :for="'radio-'+field+'-'+key" :name="field">{{ data['label'] }}</label>
        </div>

        <div class="form-box-item">
          <input type="radio" :id="'radio-'+field+'-tolmacsolas'" :name="field" value="tolmácsolás" @click='tolmacsolas'>
          <label :for="'radio-'+field+'-tolmacsolas'">Tolmácsolás</label>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import {fieldMixin} from '../../mixin/field'

export default {
  mixins: [
    fieldMixin
  ],
  props: [
    'serviceType'
  ],
  computed: {
    service_type: {
      get() {
        return this.serviceType
      },
      set(val) {
        this.$emit(`update:serviceType`,val)
      }
    }
  },
  methods: {
    tolmacsolas() {
      location.href="/tolmacsolas"
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 600px) {
  .forditas-wrapper .form-box .row.radio-selection{
    // display: none;
    display: block;
  }
  .radio-selection {
    .form-box-item{
      display: block;
      border-left: none !important;
    }
  }
}
</style>
